import fetchApi from "../fetchApi";
export const DisableUser = async (id) => {
    const options = {
        method: 'DELETE',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "id": id
        }),
        redirect: 'follow'
    }

    return await fetchApi(`users`, options);
};